import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {FaYoutube} from 'react-icons/fa'
const parasocials = () => {
  return (
    <div className='header__socials'>
      <a href='https://linkedin.com' target='_blank'><BsLinkedin /></a>
      <a href='https://github.com' target='_blank'><FaGithub /></a>
      <a href='https://dribble.com' target='_blank'><FaYoutube /></a>
    </div>
  )
}

export default parasocials